import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth.jsx';
import Layout from './components/Layout.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Employees from './pages/Employees.jsx';
import EmployeeProfile from './pages/EmployeeProfile.jsx';
import Attendance from './pages/Attendance.jsx';
import Payroll from './pages/Payroll.jsx';
import PayrollRun from './pages/PayrollRun.jsx';
import Advances from './pages/Advances.jsx';
import Incidents from './pages/Incidents.jsx';
import Notifications from './pages/Notifications.jsx';
import Reports from './pages/Reports.jsx';
import Organization from './pages/Organization.jsx';
import Users from './pages/Users.jsx';

export default function App() {
  const { user, can } = useAuth();
  const location = useLocation();

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  const canOrg = can('sites.manage') || can('departments.manage') || can('employment_types.manage');

  return (
    <Layout>
      {/* resetKey clears a caught error on navigation via a state update,
          not a remount — a `key` prop here would force-remount the whole
          Routes tree on every nav, which is what caused the crash. */}
      <ErrorBoundary resetKey={location.pathname}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/notifications" element={<Notifications />} />
          {can('employees.view') && <Route path="/employees" element={<Employees />} />}
          {can('employees.view') && <Route path="/employees/:id" element={<EmployeeProfile />} />}
          {can('attendance.view') && <Route path="/attendance" element={<Attendance />} />}
          {can('advances.view') && <Route path="/advances" element={<Advances />} />}
          {can('payroll.view') && <Route path="/payroll" element={<Payroll />} />}
          {can('payroll.view') && <Route path="/payroll/:id" element={<PayrollRun />} />}
          {can('incidents.view') && <Route path="/incidents" element={<Incidents />} />}
          {can('reports.view') && <Route path="/reports" element={<Reports />} />}
          {canOrg && <Route path="/organization" element={<Organization />} />}
          {can('users.manage') && <Route path="/users" element={<Users />} />}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ErrorBoundary>
    </Layout>
  );
}
